import React, { useEffect, useState, useRef } from 'react';
import "../assets/Wish.css";
import { db } from '../firebase';
import {
  collection,
  addDoc,
  onSnapshot,
  deleteDoc,
  doc,
  query,
  orderBy
} from 'firebase/firestore';

const Wish = () => {
  const [name, setName] = useState('');
  const [wish, setWish] = useState('');
  const [wishes, setWishes] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const sliderListRef = useRef(null);

  // 🔹 Fetch wishes from Firestore
  useEffect(() => {
    const q = query(collection(db, "wishes_SNTheWedding"), orderBy("time", "desc"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const wishList = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setWishes(wishList);
    }, (error) => {
      console.error("Error fetching wishes:", error);
      setError("Failed to load wishes.");
    });
    return () => unsubscribe();
  }, []);

  // 🔹 Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');

    if (!name.trim() || !wish.trim()) {
      setError("Please enter both your name and your wish.");
      return;
    }

    setIsSubmitting(true);
    try {
      await addDoc(collection(db, "wishes_SNTheWedding"), {
        name: name.trim(),
        message: wish.trim(),
        time: new Date().toISOString(),
      });
      setName('');
      setWish('');
      setSuccessMessage("Your wish has been sent!");
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (submitError) {
      console.error("Error adding wish:", submitError);
      setError("Failed to send wish. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  // 🔹 Duplicate list for smooth looping animation
  const duplicatedWishes = wishes.length > 0 ? [...wishes, ...wishes] : [];

  // 🔹 Delete a wish (with simple password prompt)
  const handleDelete = async (id) => {
    const password = prompt("Enter password to delete this wish:");
    if (password === "123") {
      try {
        await deleteDoc(doc(db, "wishes_SNTheWedding", id));
        setSuccessMessage("Wish deleted successfully!");
        setTimeout(() => setSuccessMessage(''), 3000);
      } catch (deleteError) {
        console.error("Error deleting wish:", deleteError);
        setError("Failed to delete wish. Please try again.");
      }
    } else if (password !== null) {
      alert("Incorrect password.");
    }
  };

  return (
    <div className="wish-container">
      {/* Submit Form Card */}
      <div className="card submit-card">
        <h2>ផ្ញើរសារជូនពរ</h2>
        <form onSubmit={handleSubmit} className="wish-form">
          <input
            type="text"
            placeholder="ឈ្មោះ..."
            value={name}
            onChange={(e) => setName(e.target.value)}
            className={`wish-input ${error && !name.trim() ? 'input-error' : ''}`}
            disabled={isSubmitting}
            aria-label="Your Name"
          />
          <input
            type="text"
            placeholder="សរសេរសារជូនពរ..."
            value={wish}
            onChange={(e) => setWish(e.target.value)}
            className={`wish-input ${error && !wish.trim() ? 'input-error' : ''}`}
            disabled={isSubmitting}
            aria-label="Your Wish Message"
          />
          <button type="submit" className="wish-button" disabled={isSubmitting}>
            {isSubmitting ? 'កំពុងផ្ញើរ...' : 'ផ្ញើរ'}
          </button>
          {error && <p className="message-error">{error}</p>}
          {successMessage && <p className="message-success">{successMessage}</p>}
        </form>
      </div>

      {/* Received Wishes Card */}
      <div className="card wishes-card">
        <h3 className="text-center">សារជូនពរ</h3>
        {wishes.length === 0 ? (
          <p className="no-wishes-message">No wishes yet. Be the first to send one!</p>
        ) : (
          <div className="slider-wrapper">
            <ul className="slider-list" ref={sliderListRef}>
              {duplicatedWishes.map((w, i) => (
                <li key={`${w.id}-${i}`} className="wish-item">
                  <div className="wish-content">
                    <strong>{w.name}:</strong> {w.message}
                    <div className="wish-time">{new Date(w.time).toLocaleString()}</div>
                  </div>
                  <button
                    className="delete-button"
                    onClick={() => handleDelete(w.id)}
                    aria-label={`Delete wish from ${w.name}`}
                  >
                    🗑
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default Wish;
